import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'

import basics from './libs/basics-tools'
//plugins
import vant from "./plugins/vant";
import { Dialog } from 'vant';
import * as  filters  from './libs/filter'

Object.keys(filters).forEach(key=>{
  Vue.filter(key,filters[key]);
})

// 公共样式css
import './assets/css/common.css'
import './assets/css/main.scss'

Vue.config.productionTip = false;
Vue.use(vant);
Vue.use(Dialog);
Vue.use(basics)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
